// src/utils/results/resultNavigation.js

export function buildResultPath({ variant, docid, context, tab }) {
  if (!variant || !docid) return null;

  const params = new URLSearchParams({
    variant,

    docid,
  });

  if (context) params.set("context", context);

  if (tab) params.set("tab", tab);

  return `/result?${params.toString()}`;
}
